import { pickBy } from 'lodash';

export default {
  responseParser: (request) => {
    const data = request.then(response => {
      if (Array.isArray(response.data)) {
        return response.data;
      } else {
        return Object.assign({}, response.data);
      }
    });
    Object.defineProperty(data, '$response', { value: request });

    return data;
  },

  buildQueryParamsStr (params) {
    params = pickBy(params, i => i !== undefined && i !== null);
    let paramsStr = Object.keys(params).map(k => k + '=' + params[k]).join('&');
    paramsStr = paramsStr ? '?' + paramsStr : '';

    return paramsStr;
  }
};
